import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeUserRole } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

interface RemoveRoleParams {
    userId: string;
    roleId: string;
}

export const useRemoveRoleMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, RemoveRoleParams>({
        mutationFn: ({ userId, roleId }) => removeUserRole(userId, roleId),
        onSuccess: (_, { userId }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.roles(userId) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
